import LucideIcon from "@components/Atoms/Icon/LucideIcon";
import { MenuItemIconButton as UiKitMenuItemIconButton } from "ics-ui-kit/components/menu-item";
import { forwardRef } from "react";
import type { ExtractComponentGeneric } from "../../lib/extractComponentGeneric";

type UiKitMenuItemIconButtonProps = ExtractComponentGeneric<typeof UiKitMenuItemIconButton>;

export interface MenuItemIconButtonProps extends Omit<UiKitMenuItemIconButtonProps, "icon"> {
	icon?: string;
}

/**
 * Forwards its ref: used as a Radix `asChild` trigger this button is the popper's anchor, and with
 * no ref the popper has nothing to measure and renders its content at the document origin.
 */
export const MenuItemIconButton = forwardRef<HTMLButtonElement, MenuItemIconButtonProps>(
	({ icon, ...otherProps }, ref) => {
		const Icon = icon && LucideIcon(icon);
		if (!Icon) return null;

		// biome-ignore lint/suspicious/noExplicitAny: pre-existing signature; typing it properly is unrelated to this change
		return <UiKitMenuItemIconButton icon={Icon as any} ref={ref} {...otherProps} />;
	},
);
MenuItemIconButton.displayName = "MenuItemIconButton";
